import { staffUserSeed } from './staffUsers';

let staffUsers = staffUserSeed.map((s) => ({
  ...s,
  passwordSet: s.passwordSet !== false,
}));

export function getStaffUsers() {
  return staffUsers;
}

export function findStaffById(staffId) {
  return staffUsers.find((s) => s.staffId === staffId) || null;
}

export function addStaffUser(user) {
  staffUsers = [...staffUsers, user];
  return user;
}

export function updateStaffUser(staffId, patch) {
  staffUsers = staffUsers.map((s) =>
    s.staffId === staffId ? { ...s, ...patch, staffId: s.staffId } : s,
  );
  return findStaffById(staffId);
}

/** Set / reset login password (UI mock — stores flag only, not plain text). */
export function updateStaffPassword(staffId) {
  return updateStaffUser(staffId, {
    passwordSet: true,
    passwordUpdatedAt: new Date().toISOString(),
  });
}

export function nextStaffId() {
  const nums = staffUsers
    .map((s) => {
      const m = String(s.staffId).match(/(\d+)$/);
      return m ? Number(m[1]) : 0;
    })
    .filter((n) => n > 0);
  const max = nums.length ? Math.max(...nums) : 0;
  return `STF-${String(max + 1).padStart(3, '0')}`;
}
